import * as React from "react";

import style from "./style.module.css";

interface PageSizeLinksProps {
  perPage: number;
  onChangePageSize(size: number): void;
}

export function PageSizeLinks(props: PageSizeLinksProps) {
  const { perPage, onChangePageSize } = props;

  const PageSizeLink = ({ newSize }: { newSize: number }) => {
    const onClickPageSizeLink = (size: number) => () => onChangePageSize(size);
    if (newSize === perPage) {
      return <span> {newSize} </span>;
    }
    return (
      <a className={style.pageSizeLink} onClick={onClickPageSizeLink(newSize)}>
        {newSize}
      </a>
    );
  };

  return (
    <div className="float-end page-sizes">
      <PageSizeLink newSize={10} />
      <PageSizeLink newSize={30} />
      <PageSizeLink newSize={50} />
      <PageSizeLink newSize={100} />
    </div>
  );
}
